.content {
  position: relative;
  display: grid;
  grid-area: content;
  grid-template-rows: [content] 100%;
  overflow: hidden;
}
